import styled from 'styled-components';

export const SectionStyled = styled.section`
  padding-top: 40px;
  padding-bottom: 40px;

  @media screen and (min-width: 1280px) {
    padding-top: 60px;
    padding-bottom: 60px;
  }
`;
